import React from "react";
import PageContainer from "../../components/container/Container";
import bg1 from "../../assets/images/Banner_imgs/case_study.jpg";
import { caseStudies } from "../../data/caseStudies";
import { Link } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";

function CaseStudies() {
  return (
    <PageContainer 
      title={"Case Studies - CodeElan Technologies"}
      description={"Explore our successful case studies showcasing AI/ML solutions, computer vision implementations, and testing automation projects that have transformed businesses."}
    >
      {/* Hero Section */}
      <section className="hero-section contact-hero">
        <div className="hero-background">
          <div className="hero-overlay"></div>
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-8 mx-auto text-center">
                <div className="hero-content">
                  <div className="hero-accent"></div>
                  <h1 className="hero-title">
                    Our <span className="text-primary">Case Studies</span>
                  </h1>
                  <p className="hero-subtitle">
                    Discover how our AI/ML solutions, computer vision, and testing automation have transformed businesses across industries
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Case Studies Section */}
      <section className="section">
        <div className="container">
          <div className="row justify-content-center mb-5">
            <div className="col-lg-8 text-center">
              <h2 className="section-title">Success Stories</h2>
              <p className="section-subtitle">
                Real-world examples of how our technology solutions have delivered measurable results for our clients
              </p>
            </div>
          </div>
          <div className="row">
            {caseStudies.map((item, index) => {
              return (
                <div className="col-lg-4 col-md-6 mb-4" key={index}>
                  <div className="case-study-card">
                    <div className="case-study-image">
                      <img src={item.image} className="img-fluid" alt={item.title} />
                    </div>
                                         <div className="case-study-content">
                       <h4 className="case-study-title">
                         <Link to={`/case-studies/${item.id}`}>
                           {item.title}
                         </Link>
                       </h4>
                       <p className="case-study-description">{item.desc}</p>
                       <div className="case-study-link-wrapper">
                         <Link
                           to={`/case-studies/${item.id}`}
                           className="case-study-link"
                         >
                           Read More <FiArrowRight className="ms-2" />
                         </Link>
                       </div>
                     </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section cta-section">
        <div className="container">
          <div className="row justify-content-center text-center">
            <div className="col-lg-8">
              <h2 className="section-title">Ready to Start Your Success Story?</h2>
              <p className="section-subtitle">
                Let's discuss how our solutions can help you achieve similar results for your business
              </p>
              <div className="cta-buttons">
                <Link to="/contactus" className="btn btn-primary btn-lg">
                  Get In Touch
                  <FiArrowRight className="ms-2" />
                </Link>
                <Link to="/aboutus" className="btn btn-outline-primary btn-lg ms-3">
                  Learn More About Us
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </PageContainer>
  );
}

export default CaseStudies;
